import { captureException } from "@sentry/react";
import { useColorScheme } from "web_myplann/Infrastructure/Themes/ColorSchemeProvider";
import { useIsDarkMode } from "web_myplann/Shared/Renderer/useIsDarkMode";
import { device } from "web_myplann/Utils/device";

export const useDarkModeToggle = () => {
	const { setMode } = useColorScheme();
	const isDarkMode = useIsDarkMode();

	const toggle = async () => {
		const enableDarkMode = !isDarkMode;

		if (window.ReactNativeWebView) {
			await device.switchDarkMode(enableDarkMode).catch(captureException);
		} else {
			setMode({ paletteMode: enableDarkMode ? "dark" : "light" });
		}
	};

	return { isDarkMode, toggle };
};
